import {Component, inject} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {Router} from "@angular/router";
import {CommonModule} from "@angular/common";

import {ToastrService} from "ngx-toastr";
import {AutofocusDirective} from "../../global/directives/autofocus.directive";
import {DataService} from "../../global/services/data.service";
import {ScCheckboxReCaptcha} from "@semantic-components/re-captcha";

@Component({
    selector: 'app-demo',
    templateUrl: './demo.component.html',
    styleUrl: './demo.component.scss',
    standalone: true,
    imports: [FormsModule, AutofocusDirective, CommonModule, ScCheckboxReCaptcha]
})
export class DemoComponent {

    private router = inject(Router);
    private dataService = inject(DataService);
    private toastrService = inject(ToastrService);

    demoData = {
        companyName: "",
        email: "",
        password: "",
        confirmPassword: ""
    };

    recaptchaResponse: string = '';
    registrationInProgress = false;

    passwordsMatch(): boolean {
        return this.demoData.password === this.demoData.confirmPassword && this.demoData.password !== '';
    }

    setupDemo(): void {
        if (this.demoData.password !== this.demoData.confirmPassword) {
            this.toastrService.error('Passwörter stimmen nicht überein');
            return;
        }

        if (!this.recaptchaResponse) {
            this.toastrService.error('Bitte bestätigen Sie, dass Sie kein Roboter sind');
            return;
        }

        this.registrationInProgress = true;

        this.dataService.request('universe.Admin/setupDemo', {
            companyName: this.demoData.companyName,
            email: this.demoData.email,
            password: this.demoData.password,
            recaptchaToken: this.recaptchaResponse
        }).subscribe({
            next: (response: any) => {
                this.registrationInProgress = false;

                if (response.success) {
                    this.toastrService.success('Demo-Zugang wurde erfolgreich angelegt. Sie können Sich nun anmelden');
                    this.router.navigate(['/login']).catch();
                } else {
                    this.toastrService.error(response.error);
                }
            },
            error: (error) => {
                this.registrationInProgress = false;
                this.toastrService.error('Ein Fehler ist aufgetreten');
                console.error('Error:', error);
            }
        });
    }
}
